export const DEFAULT_DESIGNER = {
    title: 'Product Shot',
    assets: [],
    results: [],
};
